// this linting rule was flagging errors even after they had been addressed in various manners
/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import './multiSelectDropdown.css';
import { FaAngleDown as ArrowDown } from 'react-icons/lib/fa';

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      properties: [],
      // listToSearchThrough: this.props.list,
      // searchBar: 'Search',
      showItems: false,
      // term: '',
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

    handleInputChange = (event) => {
      const { list } = this.props;
      const { value } = event.target;
      // await this.setState({
      //   term: value,
      // });
      const filteredArray = list
        .filter(item => item.name === value)
        .map(x => x.name);
      this.setState({
        properties: filteredArray,
      });
    }

    handleClick() {
      const { showItems } = this.state;
      if (! showItems) {
        document.addEventListener('click', this.handleOutsideClick, false);
      } else {
        document.removeEventListener('click', this.handleOutsideClick, false);
      }
      this.setState(prevState => ({
        showItems: ! prevState.showItems,
      }));
    }

    handleOutsideClick(e) {
      if (this.node.contains(e.target)) {
        return;
      }
      this.handleClick();
    }

    renderItemsToAddToSearchBar = () => {
      const { properties } = this.state;
      properties.map(item => (<div>{` ${item} `}</div>));
    }

    render() {
      const {
        list = [], checkboxClicked, failureCheckboxClicked, showOnFailure,
      } = this.props;
      const { showItems } = this.state;

      const options = Object.keys(list).map((property, index) => (
        <div className="properties-list-row" key={property}>
          <div className="cell">
            {property}
          </div>
          <div className="cell">
            {parseFloat(list[property].score, 10).toFixed(2)}
          </div>
          <div className="cell">
            <div className="box"
              role="button"
              tabIndex={index + 0}
              value={property}
              onClick={checkboxClicked}
              onKeyDown={checkboxClicked}
            />
          </div>
          { showOnFailure && (
            <div className="cell">
              <div className="box"
                role="button"
                tabIndex={index + 1}
                value={property}
                onClick={failureCheckboxClicked}
                onKeyDown={checkboxClicked}
              />
            </div>
          )}
        </div>
      ));
      return (
        <div className="ddown">
          <div className="dropdown-container">
            <div className="dropdown-header"
              onClick={this.handleClick}
              ref={(node) => { this.node = node; }}
            >
              <label className="select-properties-label"
                htmlFor="properties-list"
              >
                {'Properties List'}
                <ArrowDown />
              </label>
            </div>

            <div className={showItems ? 'dropdown-list-container show' : 'dropdown-list-container hide'}>
              <div className="properties-list"
                ref={(node) => { this.node = node; }}
              >
                <div className="properties-list-row header">
                  <div className="cell">
                    {'Property Name'}
                  </div>
                  <div className="cell">
                    {'% used'}
                  </div>
                  <div className="cell">
                    {'Use for Model'}
                  </div>
                  { showOnFailure && (
                    <div className="cell">
                      {'Activated on Failure'}
                    </div>
                  )}
                </div>
                {options}
              </div>
            </div>
          </div>
        </div>

      );
    }
}

export default Dropdown;
